import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Unit from "../../../containers/modules/master/unit";

export default function UnitRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="unit"
      index
      element={
        <AccessControl
          name={"Unit List"}
          auth={authUser}
          component={() => <Unit authUser={authUser} />}
        />
      }
      key={"Unit List"}
    />
  );
}
